import $ from 'jquery';
import Masonry from 'masonry-layout';
import Flickity from 'flickity';
import 'flickity-imagesloaded';
import layout from '../Layout';

export default class BlogLayout {
  constructor(el, options = {}) {
    this.$el = $(el);
    this.options = options;

    this.update = this.update.bind(this);
    layout.onBreakpointChange(this.update);
    this.update();
  }

  unload() {
    this._destroyMasonry();
    this._destroyFlickity();
    layout.offBreakpointChange(this.update);
  }

  update() {
    // Use flickity at S and M breakpoints if enabled, otherwise use masonry
    const flickity = layout.isBreakpoint('S') || (layout.isBreakpoint('M') && this.options.flickity);

    if (flickity) {
      this._destroyMasonry();
      this._initFlickity();
    } else {
      this._destroyFlickity();
      this._initMasonry();
    }
  }

  _initMasonry() {
    if (!this.$el.length) return;

    // Just re-layout items
    if (this.masonry) {
      this._destroyMasonry();
    }

    // Create new masonry grid
    this.masonry = new Masonry(this.$el[0], {
      columnWidth: '[data-article-excerpt-masonry-item-sizer]',
      gutter: '[data-article-excerpt-masonry-gutter-sizer]',
      itemSelector: '[data-article-excerpt]',
      percentPosition: true,
    });

    this.masonry.layout();

    $('.article-excerpt-image [data-rimg]', this.$el).on('rimg:load', () => {
      this.masonry.layout();
    });
  }

  _destroyMasonry() {
    if (this.masonry) {
      this.masonry.destroy();
      this.masonry = null;
    }

    // Clear styles
    $('[data-article-excerpt]', this.$el).attr('style', '');
  }

  _initFlickity() {
    if (!this.options.flickity) return;
    if (!this.$el.length) return;

    if (this.flickity) {
      this._destroyFlickity();
    }

    this.flickity = new Flickity(this.$el[0], {
      cellAlign: 'left',
      cellSelector: '[data-article-excerpt]',
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      imagesLoaded: true,
    });
  }

  _destroyFlickity() {
    if (this.flickity) {
      this.flickity.destroy();
      this.flickity = null;
    }

    // Clear styles
    $('[data-article-excerpt]', this.$el).attr('style', '');
  }
}
